import { createSlice } from '@reduxjs/toolkit';
import { ServicesSearchTypes } from 'src/components/ToggleBox/ToggleBox.types';
import { SortTypes } from 'src/screens/services/ServicesScreen.types';

import { ServicesInitialStateType } from '../types/servicesTypes';
const name = 'serviceTemplates';

const INITIAL_TYPE: ServicesInitialStateType = {
  services: [],
  filteredServices: [],
  isServicesLoading: false,
  isFilteredServicesLoading: false,
  selectedToggleBoxValue: ServicesSearchTypes.SERVICE,
  sortByValue: SortTypes.NAME,
  searchInputValue: '',
  searchParams: null,
  error: null,

  isCreateRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
};

const serviceTemplatesSlice = createSlice({
  name,
  initialState: INITIAL_TYPE,
  reducers: {
    updateSearchParams: (state, action) => {
      const { selectedToggleBox, searchInput, sortBy } = action.payload;
      state.selectedToggleBoxValue = selectedToggleBox;
      state.searchInputValue = searchInput;
      state.sortByValue = sortBy;
    },

    getServiceTemplates: state => {
      state.isServicesLoading = true;
    },
    getServiceTemplatesSuccess: (state, action) => {
      state.isServicesLoading = false;
      state.services = action.payload;
    },
    getServiceTemplatesFailure: (state, action) => {
      state.isServicesLoading = false;
      state.error = action.payload;
    },

    getFilteredServiceTemplates: (state, action) => {
      state.isFilteredServicesLoading = true;
      state.searchParams = action.payload;
    },
    getFilteredServiceTemplatesSuccess: (state, action) => {
      state.isFilteredServicesLoading = false;
      state.filteredServices = action.payload;
    },
    getFilteredServiceTemplatesFailure: (state, action) => {
      state.isFilteredServicesLoading = false;
      state.error = action.payload;
    },

    createServiceTemplate: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    createServiceTemplateSuccess: state => {
      state.isCreateRequestLoading = false;
    },
    createServiceTemplateFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    updateServiceTemplate: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateServiceTemplateSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateServiceTemplateFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeServiceTemplate: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeServiceTemplateSuccess: state => {
      state.isRemoveRequestLoading = false;
    },
    removeServiceTemplateFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSearchParams,

  getServiceTemplates,
  getServiceTemplatesFailure,
  getServiceTemplatesSuccess,

  getFilteredServiceTemplates,
  getFilteredServiceTemplatesSuccess,
  getFilteredServiceTemplatesFailure,

  createServiceTemplate,
  createServiceTemplateFailure,
  createServiceTemplateSuccess,

  updateServiceTemplate,
  updateServiceTemplateFailure,
  updateServiceTemplateSuccess,

  removeServiceTemplate,
  removeServiceTemplateFailure,
  removeServiceTemplateSuccess,
} = serviceTemplatesSlice.actions;

export default serviceTemplatesSlice.reducer;
